// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { SignatureCarousel } from './SignatureCarousel';
export { hotelCarousel } from './__mock__/SignatureCarousel';
